import React from 'react'
import styled from 'styled-components'
import {useWindowMode} from 'windows'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {TransactionWithdrawConfirmationItemProps} from './TransactionWithdrawConfirmationItemProps'

const StyledItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: ${convertUnit(10)};
`

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  width: ${convertUnit(200)};
`

export default function TransactionWithdrawConfirmationItem({
  leftText,
  rightText,
  fontSize = 'm',
  leftFontWeight = 'medium',
  rightFontWeight = 'regular',
  rightTextColor = 'black',
  marginTop = 0,
}: TransactionWithdrawConfirmationItemProps) {
  const mode = useWindowMode()
  return (
    <StyledItemContainer style={{marginTop: convertUnit(marginTop)}}>
      <StyledColumn>
        <Paragraph fontSize={fontSize} fontWeight={leftFontWeight}>
          {leftText}
        </Paragraph>
      </StyledColumn>

      <StyledColumn>
        <Paragraph
          fontSize={fontSize}
          fontWeight={rightFontWeight}
          color={rightTextColor}
          style={
            mode === 'mobile' ? {paddingLeft: '25px'} : {paddingLeft: '50px'}
          }>
          {rightText}
        </Paragraph>
      </StyledColumn>
    </StyledItemContainer>
  )
}
